var map = {
	"./": 98,
	"./documentEditTranslation": 176,
	"./documentEditTranslation.ts": 176,
	"./index": 98,
	"./index.ts": 98,
	"./languages": 79,
	"./languages.ts": 79,
	"./pl": 177,
	"./pl.ts": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 286;